module.exports = "<kd-repeater\r\n    list=\"$ctrl.results\"\r\n    group=\"pagadora\">\r\n  <div ng-repeat=\"(pagadora, viaticos) in $groups track by pagadora \">\r\n    <div class=\"kd-item padding-md --text-light\">\r\n      {{::pagadora}}\r\n    </div>\r\n    <div ng-repeat=\"item in viaticos track by $index\">\r\n      <viaticos-pagos-pago-item\r\n          data=\"item\"\r\n          on-change=\"$ctrl.editar($event.detail)\"></viaticos-pagos-pago-item>\r\n    </div>\r\n  </div>\r\n</kd-repeater>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/pagos/lista/template.html
// module id = 3260
// module chunks = 0